import React from 'react';
import styled from 'styled-components';

interface SectionContainerProps {
  children: React.ReactNode;
  background?: 'white' | 'light-gray';  // Gardé pour la compatibilité, mais n'aura plus d'effet visuel
  spacing?: 'small' | 'medium' | 'large';
  className?: string;
  id?: string;
  noDivider?: boolean; // Nouvelle prop pour contrôler si un diviseur doit être affiché
}

const Section = styled.section<{ $background?: string; $spacing?: string; $noDivider?: boolean }>`
  background-color: var(--color-background); // Toujours blanc
  padding: ${(props) => {
    switch (props.$spacing) {
      case 'small':
        return 'var(--spacing-sm) 0';
      case 'medium':
      default:
        return 'var(--spacing-lg) 0'; // 48px
      case 'large':
        return 'var(--spacing-md) 0';
    }
  }};
  position: relative;

  ${props => !props.$noDivider && `
    &:not(:first-child)::before {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 50px;
      height: 1px;
      background-color: var(--color-medium-gray);
      opacity: 0.5;
    }
  `}
`;

const SectionContainer: React.FC<SectionContainerProps> = ({
  children,
  background = 'white', // Paramètre gardé pour la compatibilité, mais ignoré dans le style
  spacing = 'medium',
  className,
  id,
  noDivider = false,
}) => {
  return (
    <Section 
      $background={background} 
      $spacing={spacing} 
      $noDivider={noDivider}
      className={className} 
      id={id}
    >
      <div className="container">
        {children}
      </div>
    </Section>
  );
};

export default SectionContainer;
